<template>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search customer name or cinolla number..">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="last_name">Name</sortableTh>
            <th>Cinolla Number</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="created_at">Created at</sortableTh>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="customer in data" :key="customer.id">
                <td>{{ customer.name }}</td>
                <td>{{ customer.cinolla_number }}</td>
                <td>{{ customer.created_at }}</td>
                <td v-html="customer.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const orderBy = ref('last_name');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
